module.exports = "/images/video-camera.svg?2bd37b1b45f176a832e79edbc925b847";